// Lê o código de barras (ou o QR code) de uma foto (0.17.0). Usa o leitor do
// próprio navegador quando ele lê Code 128 (o Chrome do Android) e, sem ele
// (iPhone, computador), o ZXing em WebAssembly: o arquivo (uns 1 MB) é baixado
// só na primeira vez que alguém usa e fica guardado no celular.
import arquivoDoLeitor from 'zxing-wasm/reader/zxing_reader.wasm?url';

const FORMATOS = ['code_128', 'qr_code'];
let Leitor = null;

async function leitor() {
  if (Leitor) return Leitor;
  const nativo = globalThis.BarcodeDetector;
  if (nativo?.getSupportedFormats) {
    try {
      const formatos = await nativo.getSupportedFormats();
      if (FORMATOS.every((f) => formatos.includes(f))) {
        Leitor = nativo;
        return Leitor;
      }
    } catch {
      // usa o ZXing
    }
  }
  const { BarcodeDetector, prepareZXingModule } = await import('barcode-detector/ponyfill');
  prepareZXingModule({
    overrides: { locateFile: (caminho, prefixo) => (caminho.endsWith('.wasm') ? new URL(arquivoDoLeitor, location.href).href : prefixo + caminho) },
  });
  Leitor = BarcodeDetector;
  return Leitor;
}

// Os textos dos códigos achados na foto (vazio: nenhum).
export async function lerCodigosDaFoto(arquivo) {
  const Detector = await leitor();
  const imagem = await createImageBitmap(arquivo);
  try {
    const achados = await new Detector({ formats: FORMATOS }).detect(imagem);
    return achados.map((a) => a.rawValue).filter(Boolean);
  } finally {
    imagem.close?.();
  }
}
